
import request from '@/utils/request'

export default {
  getDetailListByEntity(data) {
    return request({
      url: '/detail/getDetailListByEntity',
      method: 'post',
      data
    })
  },
  getOneDetailByResourceGuid(data){
    return request({
      url: '/detail/getOneDetailByResourceGuid',
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/detail.js